// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.ongoingcare.TargetIopResponse */
/* istanbul ignore next */
@GandalfModel
export class TargetIopResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	comment!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	dateEntered!: Date;

	@GandalfProperty({ designType: Number })
	id!: number;

	@GandalfProperty({ designType: Number })
	patientId!: number;

	@GandalfProperty({ designType: Number })
	targetOd!: number | null;

	@GandalfProperty({ designType: Number })
	targetOs!: number | null;

}
